import React from 'react';
import SimpleCard from './SimpleCard';

function Login() {
  return <SimpleCard />;
}

export default Login;
